import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionTitle: {
		id: 'fastshift.dc-instance-details.instance-summary.section-title',
		defaultMessage: 'Instance details',
		description: 'Heading for the Data Center instance summary section.',
	},
	productLabel: {
		id: 'fastshift.dc-instance-details.instance-summary.product-label',
		defaultMessage: 'Product',
		description: 'Column heading for the Data Center product type.',
	},
	versionLabel: {
		id: 'fastshift.dc-instance-details.instance-summary.version-label',
		defaultMessage: 'Version',
		description: 'Column heading for the Data Center product version.',
	},
	connectionLabel: {
		id: 'fastshift.dc-instance-details.instance-summary.connection-label',
		defaultMessage: 'Connection',
		description: 'Column heading for the Data Center connection status.',
	},
	serverIdLabel: {
		id: 'fastshift.dc-instance-details.instance-summary.server-id-label',
		defaultMessage: 'Server ID',
		description: 'Column heading for the Data Center server ID.',
	},
	loadingLabel: {
		id: 'fastshift.dc-instance-details.instance-summary.loading-label',
		defaultMessage: 'Loading instance details',
		description: 'Accessible label for the instance summary loading indicator.',
	},
	emptyValue: {
		id: 'fastshift.dc-instance-details.instance-summary.empty-value',
		defaultMessage: 'Unknown',
		description: 'Fallback shown for an instance summary value that is not available.',
	},
});
